import {NgModule} from '@angular/core';
import {HomeSliderComponent} from './components/home-slider/home-slider.component';
import {HomePageComponent} from './home-page.component';
import {SearchEngineModule} from '../../search-engine/search-engine.module';
import {RouterModule, Routes} from '@angular/router';
import {SharedModule} from '../../shared/shared.module';

import {HomeSpecialsComponent} from './components/home-specials/home-specials.component';
import {HomeEngineContainerSliderComponent} from './components/home-engine-container-slider/home-engine-container-slider.component';
import {HomeEngineContainerStaticComponent} from './components/home-engine-container-static/home-engine-container-static.component';
import {HomeTagsComponent} from './components/home-tags/home-tags.component';
import {HomeDestinationsComponent} from './components/home-destinations/home-destinations.component';
import {HomeUtilitiesComponent} from './components/home-utilities/home-utilities.component';
import {HomeNewsletterComponent} from './components/home-newsletter/home-newsletter.component';
import {HomeBannerFullComponent} from './components/home-banner-full/home-banner-full.component';
import {HomeAppointmentsComponent} from './components/home-appointments/home-appointments.component';
import {HomeNewsComponent} from './components/home-news/home-news.component';
import { CommonModule } from '@angular/common';
import { CmsModule } from '../../cms/cms.module';
import {HomePageSkeletonModule} from "../home-page-skeleton/home-page-skeleton.module";


const routes: Routes = [
  {path: '', component: HomePageComponent},
];
@NgModule({
  declarations: [
    HomeSliderComponent,
    HomePageComponent,
    HomeSpecialsComponent,
    HomeEngineContainerSliderComponent,
    HomeEngineContainerStaticComponent,
    HomeTagsComponent,
    HomeDestinationsComponent,
    HomeUtilitiesComponent,
    HomeNewsletterComponent,
    HomeBannerFullComponent,
    HomeAppointmentsComponent,
    HomeNewsComponent
  ],
    imports: [
        CmsModule,
        CommonModule,
        SharedModule,
        SearchEngineModule,
        RouterModule.forChild(routes),
        HomePageSkeletonModule
    ],
  exports: [
    //HomePageComponent
    RouterModule
  ],
  providers: []
})
export class HomePageModule {
}
